import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-6">Terms of Service</h1>
        <div className="prose max-w-none bg-white p-8 rounded-lg shadow-sm">
          <p className="text-sm text-gray-600 mb-6">Last Updated: January 2025</p>
          
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing and using Profind.ca, you accept and agree to be bound by these Terms of Service. If you do not agree, please do not use our platform.</p>
          
          <h2>2. Use of Service</h2>
          <p>Profind.ca provides a platform connecting homeowners with service professionals. You agree to use the service only for lawful purposes and in accordance with these terms.</p>
          
          <h2>3. User Accounts</h2>
          <p>You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities that occur under your account.</p>
          
          <h2>4. Professional Services</h2>
          <p>Profind.ca is a platform connecting users with independent service professionals. We do not employ these professionals and are not responsible for the quality of their work.</p>
          
          <h2>5. Payments and Subscriptions</h2>
          <p>Professional subscriptions are billed monthly or annually. All payments are processed securely through Stripe. Refund policies are subject to our refund terms.</p>
          
          <h2>6. Content and Conduct</h2>
          <p>Users agree not to post inappropriate, offensive, or illegal content. We reserve the right to remove content and suspend accounts that violate these terms.</p>
          
          <h2>7. Limitation of Liability</h2>
          <p>Profind.ca is not liable for any damages arising from the use of our platform or services provided by professionals found through our platform.</p>
          
          <h2>8. Changes to Terms</h2>
          <p>We reserve the right to modify these terms at any time. Continued use of the service constitutes acceptance of modified terms.</p>
          
          <h2>9. Contact</h2>
          <p>For questions about these terms, contact us at legal@profind.ca</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsPage;